import { useContext, useEffect, useState } from 'react';
import ReactPlayer from 'react-player'
import './../../style/videoFlipCard.css';
import './../../style/multChoice.css';
import {adjustListTags} from "../Page/utils/htmlAdjustments"

function FlipCard({front, back}){
    const [flip, setFlip] = useState(false)


    const toggleFlip = () => {
        setFlip(oldFlip => !oldFlip)
    }


    // HIER ÄNDERN ____________________________________________________________################################################################################
    //TODO: Flip Effekt: Optisch akzeptable und flippende Version zusammenführen! (FlipCard & FlipCard_alt)

    // TODO: LISTS not shown, why????
    return (
        <div className='container example-container'>
            <div className='card_2 card-video'>
                <div className='card-body_2'>
                    <div className='video-flip-card_2'>
                        <div className={"video-flip-card-inner_2 " + (flip === true ? "flip" : "")}>
                            <div className='video-flip-card-front'> 
                                <div className="" dangerouslySetInnerHTML={{__html: front}} />
                                <button className="btn btn-primary mt-3" onClick={toggleFlip} >Lösung ansehen</button>
                            </div>
                            <div className='video-flip-card-back '> 
                                <div className='videoResult result-txt'>

                                {
                                    <div className=" " dangerouslySetInnerHTML={{__html: adjustListTags(back)}} />

                                }
                                    
                                    <button className="btn btn-primary " onClick={toggleFlip}>Zurück</button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FlipCard